
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import ShowObjectDialog from '@/components/dialogs/ShowObjectDialog.vue';
import RendererDialog from '@/components/dialogs/RendererDialog.vue';
import {commitAddNotification} from '@/store/main/mutations';
import {readHasModuleAccess} from '@/store/main/getters';
import ShowSingleList from '@/components/dialogs/ShowSingleList.vue';
import PdfPreviewDialog from '@/components/dialogs/PdfPreviewDialog.vue';
import SentEmailDialog from '@/components/dialogs/SentEmailDialog.vue';
import RoleSettings from '@/components/extras/RoleSettings.vue';
import AlertDialogWrapper from '@/components/dialogs/AlertDialogWrapper.vue';
import AlertDialogFrame from '@/components/dialogs/AlertDialogFrame.vue';
import {IDynamicQuery} from '@/interfaces';
import ShowPermissionsDialog from '@/components/dialogs/ShowPermissionsDialog.vue';
import {SpecialFields} from '@/interfaces/constants';
import { ItemsPerPageOptions } from './consts';
import DisplayValue from '@/components/DisplayValue.vue';

@Component({
    computed: {
        SpecialFields() {
            return SpecialFields;
        },
        ItemsPerPageOptions() {
            return ItemsPerPageOptions;
        },
    },
  components: {
      DisplayValue,
      ShowPermissionsDialog,
    AlertDialogFrame,
    AlertDialogWrapper,
    RoleSettings,
    SentEmailDialog,
    PdfPreviewDialog,
    ShowSingleList,
    RendererDialog,
    ShowObjectDialog,
  },
})
export default class DynamicTableSimpleAsync extends Vue {
  @Prop(Array) public dataset;
  @Prop(Array) public headers;
  @Prop(Array) public headersRemained;
  @Prop(String) public moduleName;
  @Prop(Boolean) public canSentEmail!: boolean;
  @Prop(Boolean) public canEditRows!: boolean;
  @Prop(Boolean) public expandableTable!: boolean;
  @Prop(Function) public readDataFromAPIFunction: any;
  @Prop(Number) public totalItems;
  @Prop(Number) public numberOfPages;

  @Prop(Boolean) public hideHeaderFooter: boolean = false;

  public showSettings: boolean = false;
  public openCSDialog: boolean = false;
  private showFilter: boolean = false;
  private search: string = '';
  private canEdit: boolean = true;
  private canDelete: boolean = true;
  private selectedItem!: any;
  private options: any = {};

  private loading: boolean = true;
  private alertDialog: any = null;
  private alertHeader: any = '';
  private alertMessage: any = '';
  private timer: number = 0;

  private expanded: [] = [];

  @Watch('options')
  public watchOptions(val) {
    this.readDataFromAPI();
  }

  @Watch('search')
  public async watchSearch(val) {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (val?.length > 2) {
      this.timer = setTimeout(() => {
        this.readDataFromAPI();
      }, 300);
    } else if (val?.length === 0) {
      await this.readDataFromAPI();
    }
  }

  public async mounted() {
    if (this.moduleName) {
      // Inverso por conta do disable
      this.canEdit = !readHasModuleAccess(this.$store)({module: this.moduleName, method: 'update'});
      this.canDelete = !readHasModuleAccess(this.$store)({module: this.moduleName, method: 'delete'});
    }

    this.alertDialog = this.$refs.alert_dialog;
    this.alertHeader = `${this.$t('crud.delete')} ${this.$t('selected_item')}?`;
    this.alertMessage = this.$t('infos.delete_alert');

  }

  public async readDataFromAPI() {
    this.loading = true;
    const {page, itemsPerPage} = this.options;
    if (page === 0) {
      this.options.page = 1;
    }
    const pageNumber = page - 1;
    const skipPages = pageNumber > 0 ? pageNumber * itemsPerPage : 0;

    await this.readDataFromAPIFunction({
      skip: skipPages,
      limit: itemsPerPage > 0 ? itemsPerPage : this.totalItems,
      query_value: this.search ? this.search : '',
    } as IDynamicQuery);
    this.loading = false;
  }

  private get canSentEmailPermission() {
    if (this.canSentEmail) {
      return readHasModuleAccess(this.$store)({module: 'direct_mail', method: 'can_sent'});
    }
  }

  private getFormFileID(item) {
    return item?.form_files_id;
  }

  private isFormFileValue(item) {
    return item && typeof item === 'object' && (item.type || item.name || item.upload_status || item.form_files_id);
  }

  private formatFormFile(item) {
    if (!item) {
      return null;
    }
    if (item.upload_status === 'pending') {
      return `${item.name || 'Arquivo'} (upload pendente)`;
    }
    if (item.form_files_id) {
      return item.name || 'Arquivo anexado';
    }
    return `${item.name || 'Arquivo'} (indisponível)`;
  }

  private labelName(key: string) {
    if (this.headersRemained) {
      return this.headersRemained.find((e) => e.value === key)?.text;
    }
    return key;
  }

  private checkType(item: any) {
    return typeof item;
  }


  private validTimestamp(timestamp) {
    const minDate = new Date('1970-01-01 00:00:01');
    const date = (new Date(timestamp));
    return date.getTime() > minDate.getTime();
  }

  private formatUser(val) {
    if (!val) {
      return '-----';
    }
    return val?.fullname;
  }

  private currentEmittedInstitution(val) {
    // @ts-ignore
    const hospitalName = val?.role?.settings?.custom_data.find((e) => e?.name === 'hospital_name')?.value;
    return hospitalName ? hospitalName : '-----' ;
  }

  private formatDate(dateTimestamp) {
    if (!dateTimestamp) {
      return '-----';
    }

    // if (typeof dateTimestamp === 'number') {
    //   dateTimestamp = this.$date(dateTimestamp);
    // }
    // @ts-ignore
    return this.$date(dateTimestamp).format('DD/MM/YYYY HH:mm');
    // return new Date(dateTimestamp).toLocaleString('pt-BR');
  }

  private rowClasses(item) {
    if (item?.delivery_completed) {
      return 'green lighten-5';
    }
    return 'max-row-width';
  }

  private editFunction(item): void {
    if (this.headers) {
      const filtered = this.headers.find((e) => {
        return e.value === 'action';
      });
      if (filtered?.router_name) {
        this.$router.push({name: filtered.router_name, params: {id: item.id}});
      } else {
        // @ts-ignore
        commitAddNotification(this.$store, {content: this.$t('notAllowed'), color: 'warning'});
      }
    }
  }

  private calcRegisteredValues(item) {
    if (!item) {
      return null;
    }
    /* tslint:disable:no-bitwise */
    const registeredValues = item?.registered_values?.length;
    if (item?.range_values?.length > 1) {
      // return `TOTAL | ${item?.range_values[1] - item?.range_values[0]} | REGISTRADOS: ${registeredValues | 0} |
      //   AUSENTES: ${item?.range_values[1] - item?.range_values[0] - (registeredValues | 0)}`;
      const total = (Number(item?.range_values[1]) + 1) - Number(item?.range_values[0]);
      const registered = registeredValues | 0;
      const missing = total - (registeredValues | 0);
      const percent = Number(registered / total * 100).toFixed(0);
      return [total, registered, missing, percent];
    }
    return registeredValues | 0;
    /* tslint:disable:no-bitwise */
  }

  private async deleteFunction(item) {
    if (this.headers) {
      const filtered = this.headers.find((e) => e.delete_function);
      if (filtered) {
        const resp = await this.alertDialog.open({width: 450}).then((result) => {
          return result;
        });
        if (resp) {
          await filtered.delete_function(item.id);
          // await this.readDataFromAPI();
        }
      } else {
        // @ts-ignore
        commitAddNotification(this.$store, {content: this.$t('notAllowed'), color: 'warning'});
      }
    }
  }
}
